/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { TextCell } from "./TextCell";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var NumericCell = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(NumericCell, _super);
    function NumericCell(a) {
        var _this = _super.call(this, a) || this;
        _this.bs(_this.b9, 2);
        _this.bw(_this.b9, 1);
        return _this;
    }
    NumericCell.prototype.bh = function (a, b, c) {
        _super.prototype.bh.call(this, a, b, c);
        if (a == "Indent" || a == "IsCollapsable") {
            this.b9.setRawStyleProperty("margin-left", this.av + this.ax + this.aw + "px");
        }
    };
    NumericCell.$t = markType(NumericCell, 'NumericCell', TextCell.$);
    return NumericCell;
}(TextCell));
export { NumericCell };
//# sourceMappingURL=NumericCell.js.map
